/**
 * Tiny EAGER opener for the size-guide panel.
 * Lets the panel open on the first click even though the (heavy) size-calculator JS is lazy-loaded,
 * so there's no first-tap race. Delegated, so it works for the trigger deep inside the variant picker.
 */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('[data-size-calc-trigger]');
    if (!btn) return;
    e.preventDefault();
    const el = document.getElementById(btn.getAttribute('data-size-calc-trigger'));
    if (!el) return;
    if (typeof el.showDialog === 'function') {
      el.showDialog();
    } else {
      const dlg = el.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    }

    // [Archies] Usage tracking — fire on OPEN (broadest signal: the shopper engaged the size tool).
    //  (a) ?szcalc=1 session marker on the URL (idempotent).
    //  (b) dataLayer 'size_calculator_opened' event (analytics-agnostic; harmless if no GTM/GA4).
    // The deeper "size_calculator_used" (a completed calculation) + the `_size_calc` line-item property
    // on add-to-cart are fired separately by size-calculator-ext.js.
    try {
      const url = new URL(window.location.href);
      const cur = url.searchParams.get('szcalc');
      // Set 'opened' on open — but never downgrade a session that already reached 'used'.
      if (cur !== 'opened' && cur !== 'used') {
        url.searchParams.set('szcalc', 'opened');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    } catch (err) { /* no-op */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'size_calculator_opened' });
    } catch (err) { /* no-op */ }
  });
})();
